module.exports = __webpack_public_path__ + "img/mlamb48.845155ef.svg";